// extracted by mini-css-extract-plugin
module.exports = {"iconBounding":"iconBounding__31KFS","icon":"icon__KcJn_","chip":"chip__2AIYb","automateRow":"automateRow__1xPGs","rest":"rest__1k9yQ"};